<template>
    <div class="my-8 flex flex-col gap-6">
        <div class="mx-auto my-1 h-[60px] w-[60px] shrink-0">
            <SvgIcon
                class="h-full w-full text-muval-success-highlight"
                name="system-check-filled"
            />
        </div>
        <div class="flex flex-col gap-2">
            <h1 class="text-center text-2xl font-medium">Success! Muval Cover added.</h1>
            <p class="text-center text-base text-muval-gray-1">
                <strong class="font-medium">Next steps:</strong> Connect your electricity, gas and/or internet.
            </p>
        </div>
        <ol class="flex flex-row justify-center gap-2">
            <li class="flex flex-col items-center gap-0.5">
                <SvgIcon
                    class="size-6 text-white"
                    name="system-check-completed"
                />
                <span class="text-[10px] text-muval-success-highlight">Booked move</span>
            </li>
            <li class="relative top-6 h-[1px] w-12 bg-muval-success-highlight"></li>
            <li class="flex flex-col items-center gap-0.5">
                <SvgIcon
                    class="size-6 text-white"
                    name="system-check-completed"
                />
                <span class="text-[10px] text-muval-success-highlight">Muval Cover</span>
            </li>
            <li class="relative top-6 h-[1px] w-12 bg-muval-gray-4"></li>
            <li class="flex flex-col items-center gap-0.5">
                <SvgIcon
                    class="size-6 text-muval-gray-4"
                    name="system-check-hollow"
                />
                <span class="text-[10px] text-muval-gray-1">Connect utilities</span>
            </li>
        </ol>
        <div class="flex flex-row justify-center gap-2">
            <MuvalButton
                quaternary
                @click="closeModal"
            >
                Skip for now
            </MuvalButton>
            <MuvalButton
                alternate
                icon="system-forward"
                icon-right
                :href="sessionStore.getConnectionPartnerUrlWithParams(connectionUrlParams)"
                target="_blank"
                @click="closeModal"
            >
                View deals online
            </MuvalButton>
        </div>
    </div>
</template>
<script setup>
const router = useRouter();
import { closeCoverUtilitiesDialog } from '@/composables/dialog';
import { useSessionStore } from '@/store';

const sessionStore = useSessionStore();

const connectionUrlParams = {
    source: 'agentcampaignfb',
};

const closeModal = () => {
    closeCoverUtilitiesDialog();

    nextTick(() => {
        router.push({ path: '/results/review' });
    });
};
</script>
